import {
  AvatarInput,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AvatarWrapper } from './change-avatar-input.styles';

const ChangeAvatarInput = ({ data, onChange }: { data: any; onChange: (file?: any) => void }) => {
  const [avatarUrl, setAvatarUrl] = useState('');
  const { t } = useTranslation('common');

  const onSelectAvatar = (file: any) => {
    setAvatarUrl(file);
    onChange(file);
  };

  return (
    <AvatarWrapper>
      <Typography fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
        {t('labels.avatar')}
      </Typography>
      <AvatarInput
        icon={ICONS.camera}
        avatar={avatarUrl || data.avatarUrl}
        onChange={onSelectAvatar}
        btnText={t(`buttons.${data.avatarUrl ? 'reload' : 'upload'}`)}
      />
    </AvatarWrapper>
  );
};

export default ChangeAvatarInput;
